import React, { FC, Fragment } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import {
    Container,
    ContentWrapper,
    InnerWrapper,
    UspsWrapper,
    StyledH4, ImageWrapper
} from "./styles"
import { UspsProps } from "./types"

const Usps: FC<UspsProps> = ({
    content,
    uspItems,
    uspsHeading
}) => {
    return <UspsWrapper>
        <Container>
            <ContentWrapper>
                {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
            </ContentWrapper>
            <InnerWrapper>
                {uspsHeading && <StyledH4>{uspsHeading}</StyledH4>}
                {uspItems && uspItems.map((usp, index) => {
                    // eslint-disable-next-line react/no-array-index-key
                    return <div key={index}>
                        {usp.image ? <ImageWrapper>
                            <GatsbyImage alt={usp.image?.alternativeText ?? ""} image={getImage(usp.image?.file)} />
                        </ImageWrapper> : <>
                            <h4>{usp.subtitle}</h4>
                            <h6>{usp.title}</h6>
                        </>}
                    </div>
                })}
            </InnerWrapper>
        </Container>
    </UspsWrapper>
}

export default Usps
